import type { Question } from '../types'

export default [
  {
    key: 'opinion',
    title: 'Hva gjør du for kyllingene?',
    description: undefined,
    options: [
      {
        value: 'no_buy',
        label: 'Jeg kjøper ikke og vil ikke kjøpe turbokylling',
        description: 'Flott avgjørelse! Du fortjener en stor takk. Ditt valg betyr mindre lidelse, smerte og frykt i livet til mange kyllinger.',
      },
      {
        value: 'reduce',
        label: 'Jeg vil redusere eller reduserer allerede forbruket av turbokylling',
        description: 'Veldig bra! Dette er et stort skritt mot bedre dyrevelferd. Jo lavere etterspørsel, jo færre kyllinger blir tvunget til å lide.',
      },
      {
        value: 'own_way',
        label: 'Jeg skal håndtere det på min måte',
        description: 'Takk for at du vil hjelpe kyllinger på din egen måte. Jo færre dyr som lider, jo bedre.',
      },
    ],
  },
  // {
  //   key: 'coop_membership',
  //   title: 'Er du medlem i Coop?',
  //   description: 'Visste du at det er medlemmene i Coop som i teorien skal bestemme? Derfor teller din stemme ekstra mye om du ikke bare signerer oppropet men om du også er medlem i Coop.',
  //   options: [
  //     {
  //       value: 'yes',
  //       label: 'Ja, jeg er medlem i Coop.',
  //       description: 'Flott! Du har en unik mulighet til å påvirke Coop til å slutte å selge turbokylling.',
  //     },
  //     {
  //       value: 'no',
  //       label: 'Nei, jeg er ikke medlem i Coop.',
  //       description: 'Det er greit. Du kan fortsatt hjelpe kyllingene ved å signere oppropet.',
  //     },
  //     {
  //       value: 'not_sure',
  //       label: 'Jeg er usikker.',
  //       description: 'Det er greit. Du kan fortsatt hjelpe kyllingene ved å signere oppropet.',
  //     },
  //     {
  //       value: 'will_not_say',
  //       label: 'Det ønsker jeg ikke å si.',
  //       description: 'Det er greit. Du kan fortsatt hjelpe kyllingene ved å signere oppropet.',
  //     },
  //   ],
  // },
] as Question[]
